<template>
    <div>
        <Head :title="__('Workplaces')" />

        <h1 class="mb-8 text-3xl font-bold">{{ __('Workplaces') }}</h1>

        <div class="mb-8">
            <input type="text" name="s" class="w-1/5" v-model="search" @input="searchWorkplaces" :placeholder="__('Search…')" >
        </div>

        <div class="overflow-x-auto bg-white rounded-md shadow">
            <table class="w-full whitespace-nowrap">
                <tr class="font-bold text-left">
                    <th class="px-6 pt-6 pb-4">Namn </th>
                    <th class="px-6 pt-6 pb-4">Antal ordrar</th>
                    <th class="px-6 pt-6 pb-4"></th>
                    <th class="px-6 pt-6 pb-4"></th>
                </tr>
                <tr class="border-b border-gray-200" v-for="workplace in workplaces" v-bind:key="workplace.value">
                    <td class="px-6 py-4">{{ workplace.label }}</td>
                    <td class="px-6 py-4">{{ workplace.count }}</td>
                    <td class="px-6 py-4">
                        <Link class="text-red-600 hover:underline" @click="deleteWorkplace(workplace.label)">Ta bort</Link>
                    </td>
                    <td class="px-6 py-4">
                        <Link class="btn-cta inline-block" :href="`/workplaces/${workplace.label}`">{{ __('View orders') }}</Link>
                    </td>
                    
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Layout         from '@/Shared/Layout'

    export default {
        components: {
            Head,
            Link,
        },
        layout: Layout,
        data: () => ({
            workplaces: [],
            searchTimeout: null,
            search: ''
        }),
        computed: {
        },
        methods: {
            fetchWorkplaces() {
                fetch('/api/clientWorkplacesFiltered', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }).then(response => response.json()).then(data => {
                  this.workplaces = data.map(workplace => {
                    return {
                        label: workplace.name,
                        count: workplace.count,
                        value: workplace.name.toLowerCase()
                    }
                  })

                  this.workplaces = this.workplaces.sort((a, b) => {
                    return a.label.localeCompare(b.label)
                  })
                })
            },
            searchWorkplaces(e) {
                clearTimeout(this.searchTimeout);
                let s = e.target.value || '';
                this.search = s;

                this.searchTimeout = setTimeout(() => {
                    this.doSearch(s)
                    this.searchTimeout = null
                
                }, 500);
            },
            doSearch(s) {
                fetch('/api/clientWorkplacesFiltered', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        search: s
                    }),
                }).then(response => response.json()).then(data => {
                    this.workplaces = data.map(workplace => {
                        return {
                            label: workplace.name,
                            count: workplace.count,
                            value: workplace.name.toLowerCase()
                        }
                    })

                    this.workplaces = this.workplaces.sort((a, b) => {
                        return a.label.localeCompare(b.label)
                    })
                })
            },
            deleteWorkplace(wp) {
                if (confirm('Ta bort arbetsplatsen och samtliga ordrar kopplade till denna?')) {
					this.$inertia.delete(`/workplaces/${wp}`)
                    setTimeout(() => {
                        this.doSearch(this.search)
                    }, 1000);
				}
            },
        },
        mounted() {
            this.fetchWorkplaces()
        }
    }
</script>
